export default {
  myAssemble: {
    line: 'I have a bottom line',
    JoinTime: 'Join Time',
    WaitingForGroup: 'Waiting',
    InProgress: 'In Progress',
    GroupSuccess: 'Success',
    GroupFailure: 'Failure',
    Specification: 'Specification',
    GroupPrice: 'Group Price',
    PleasePay: 'Please pay within the specified time or the order will be automatically cancelled',
    RemainingTime: 'Remaining Time',
    minute: 'minute',
    Second: 'Second',
    PayNow: 'Pay Now',
    PeopleGroupOnlyNeed: 'People Group, Only Need',
    PeopleToComplete: 'People to Complete',
    OnlyLeft: 'Only Left',
    End: 'End',
    InviteFriends: 'Invite Friends',
    please: 'Please go to',
    PleaseInPersonal: 'Personal Center - "My Order"',
    toview: 'to view',
    Restart: 'Restart',
    OopsNoOrderFound: 'Oops, no order found.',
    All: 'All',
    ExceededPaymentTime: 'Exceeded payment time!',
    GroupBuyingActivityEnded: 'Group buying activity ended!'
  }
}
